export const environment = {
  production: true,
  apiForLogin: 'https://www.marcusevans.com/dbproxy/content/40c892c1c51cb5c52c8e38109e04a9da',
  assetsURL: 'https://www.marcusevans.com/cmscontent/',
  doc: 'https://www.marcusevans.com/dbproxy/content/',
  secureDoc: 'https://www.marcusevans.com/dbproxy/content/',
  SecurityToken: 'XbnHRFAGG4DS7dVymw7GyptWdMb2b8ZZjHkJYg63QpjUkvNsuBcSSXBdTNdfF4ND',
  googleSiteKey: '6Lfbc8AUAAAAAHE8yDkU_zvXZEQsYaQT6nOCynLX',
  googleClientSecret: '6Ldvb7cUAAAAANlka29SLSoeFJsYWAGIcl_ZV0kn',
  // googleSiteKey: '6LdsV7EUAAAAAEaCdGPbTsw7ZsMH5pMjrXQ0vDI_',         // use this for
  // googleClientSecret: '6LdsV7EUAAAAAEcGFTtHvSfo4vCSjhnrpbi6a9eg',   // the test enviroment
  herokuProxisServer: 'https://me-cross.herokuapp.com/',
  googleURL: 'https://www.google.com/recaptcha/api/siteverify',
  emailEndPointAPI: 'http://www.marcusevans.com/EmailRestAPI/api/Emailer',
  emailType: 'ContactUs',
  emailProvider: 'LIVE_DMZ',
  emailAuthToken: '4%#o4&u)kOra!!n/Xk#p//q]FV</B/N5kA+y4}kpW>V<*cDs=n@<i[KX&^U\'?1%h',
  emailTo: 'casestudies_enquiries@marcusevans.com',
  vimeoAPIURL: 'https://vimeo.com/api/oembed.json?url=',
  viemoACCESSTOKEN: '0484ad9d4b0b61758b03d62089864d67',
  routerCookieName: 'routeTo',
  accessWebsite: 'isLogin'
};
